import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { AppSettings } from '../shared/app-settings';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BaseHttpClient {
    constructor(public router: Router, public http: HttpClient) { }

    private getHeaders(): any {
        const headers: any = {
            'Content-Type': 'application/json'
        };
        var token = localStorage.getItem(AppSettings.StorageKeys.Token);
        if (token) {
            headers['Authorization'] = 'Bearer ' + token;
        }
        const options: any = {
            headers: new HttpHeaders(headers)
        };
        return options;
    }

    post(url: string, data: any) {
        return this.http
            .post(url, data, this.getHeaders()).pipe(catchError(error => this.handleError(error)));
    }

    put(url: string, data: any) {
        return this.http
            .put(url, data, this.getHeaders()).pipe(catchError(error => this.handleError(error)));
    }

    get(url: string) {
        return this.http
            .get(url, this.getHeaders()).pipe(catchError(error => this.handleError(error)));
    }

    delete(url: string) {
        return this.http
            .delete(url, this.getHeaders()).pipe(catchError(error => this.handleError(error)));
    }

    handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            alert('Please check internet connection');
        }
        // Note: 401 handling (token refresh + redirect to login) is done by AngularInterceptor
        var errorMessage = { errorMessage: [{ message: error.message }] };
        return throwError(errorMessage);
    }
}
